import { MuiButton } from '@/components';
import { Box, Button, Divider, Grid, Theme, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SettingsLinks from './SettingsLink';
import { useDispatch } from 'react-redux';
import { logout, openDeleteModal, openSubscriptionModal, renewSubscription } from '@/store/actions';
import { logoutWithFacebook } from '@/utils';
import { useRouter } from 'next/router';

const SubscriptionSection = ({ user, manageSub, handleStartMembership, palette }: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const handleDeleteAccount = () => {
    dispatch(openDeleteModal());
  };
  const handleSubscriptionCancel = () => {
    dispatch(openSubscriptionModal());
  };

  const handleRenewSubscription = () => {
    dispatch(renewSubscription({ userId: user?.id }));
  };
  const handleLogout = async () => {
    router.push('/app/register');
    dispatch(logout());
    await logoutWithFacebook();
  };
  return (
    <Grid item xs={isMobile ? 12 : 12} mb={0.6}>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Box>
          <Typography fontSize={'1rem'} color={'#1D1D1D'}>
            Subscription
          </Typography>
          <Box display={'flex'} justifyContent={'space-between'}>
            {/* Show subscription status dynamically */}
            <Typography fontSize={'1rem'} color='#5C6372'>
              {user.isSubscriber
                ? user.subscriptionStatus === 'cancellation_scheduled'
                  ? 'Cancelled'
                  : 'Active'
                : 'Not Subscribed'}
            </Typography>
          </Box>
        </Box>
        <Box textAlign={'right'}>
          {user.isSubscriber ? (
            <>
              <Box>
                <Typography
                  variant='button'
                  sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                  color={'black'}
                  fontSize={'1rem'}>
                  <a onClick={manageSub}>Manage subscription</a>
                </Typography>
                <Typography sx={{ display: 'flex', gap: '0.4rem' }} variant='body2' color='#5C6372' fontSize={'0.8rem'}>
                  <Button sx={{ fontSize: '0.8rem', padding: '0', color: '#5C6372' }}>Payment history</Button>

                  {user.subscriptionStatus === 'cancellation_scheduled' ? (
                    <Button
                      sx={{
                        fontSize: '0.8rem',
                        padding: '0',
                        cursor: 'pointer',
                        color: '#5C6372',
                      }}
                      onClick={handleRenewSubscription}>
                      Renew subscription
                    </Button>
                  ) : (
                    <Button
                      sx={{
                        fontSize: '0.8rem',
                        padding: '0',
                        cursor: 'pointer',
                        color: '#5C6372',
                      }}
                      onClick={handleSubscriptionCancel}>
                      Cancel membership
                    </Button>
                  )}
                </Typography>
              </Box>
            </>
          ) : (
            <MuiButton
              sx={{
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '2rem',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: 'white',
                  boxShadow: 'none',
                },
              }}
              method={handleStartMembership}>
              <Typography variant='button' color={'#000'} fontSize={'0.8rem'}>
                Start membership
              </Typography>
            </MuiButton>
          )}
        </Box>
      </Box>

      {!isMobile && (
        <Divider
          style={{
            margin: '1rem 0',
            width: '100%',
            background: isMobile ? 'transparent' : 'rgba(216, 232, 246, 1)',
          }}
        />
      )}
      <SettingsLinks
        t={t}
        isMobile={isMobile}
        palette={palette}
        handleDeleteAccount={handleDeleteAccount}
        handleLogout={handleLogout}
      />
    </Grid>
  );
};

export default SubscriptionSection;
